// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Home-Main-subjects-root-3qm3x","title":"src-components-Home-Main-subjects-title-222HH","list":"src-components-Home-Main-subjects-list-23wc8","item":"src-components-Home-Main-subjects-item-325kL","itemActive":"src-components-Home-Main-subjects-itemActive-q9y9A src-components-Home-Main-subjects-item-325kL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home/Main/subjects.css
 ** module id = 270
 ** module chunks = 0
 **/